import { QueryParamListBase } from "@shared/models";

export interface UserListQueryParam extends QueryParamListBase{
  id: number | null;
  // Backend filter keys (SuperAdminRepository::$searchFields)
  search: string;
  role: string;
  company: string;
  id_number: string;
  status: string;
  order_by: string;
  order_direction: 'asc' | 'desc';
  per_page: number | string;
  page: string | number;
}
